module.exports = __webpack_public_path__ + "static/img/tu2.27dd285.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/element/tu2.png
// module id = rhO3
// module chunks = 6